var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 1.333A6.67 6.67 0 0 0 1.833 8 6.67 6.67 0 0 0 8.5 14.667 6.67 6.67 0 0 0 15.167 8 6.67 6.67 0 0 0 8.5 1.333zm-1.333 10L3.833 8l.94-.94 2.394 2.387 5.06-5.06.94.946-6 6z"
})));
export default SvgCheck;